import React, { useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import Modal from 'Components/Modal/Modal';

function Organs({ data }) {
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(!showModal);
  };
  const settings = {
    arrows: true,
    dots: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    lazyLoad: true,
    infinite: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1369,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 3,
          arrows: false,
        }
      },

      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          arrows: false,
        }
      }
    ]
  };

  return (
    <div className="search-organ-section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-heading">
              <h2>Search by Organs</h2>
              {data?.length > 4 && (
                <Link
                  className={`viewall-btn ${
                    data?.length <= 6 && 'remove-margin-left'
                  }`}
                  onClick={handleCloseModal}
                >
                  View All
                </Link>
              )}
            </div>
          </div>

          <div className="col-12">
            {data?.length > 0 && (
              <Slider
                {...settings}
                className="search-organ-content"
              >
                {data?.map((item) => (
                  <Link
                    className="search-organ-card"
                    to={`/search/${item?.organ_name.toLowerCase()}`}
                  >
                    <figure className="search-organ-icon">
                      <img
                        src={item?.organ_image}
                        alt={item.organ_name}
                      />
                    </figure>
                    <h3>{item.organ_name}</h3>
                    <div className="btn btn-sm mx-auto">
                      <span>Explore</span>
                    </div>
                  </Link>
                ))}
              </Slider>
            )}
          </div>
        </div>
      </div>
      <Modal
        header={''}
        overflow
        show={showModal}
        paddingNone
        size=""
        onClose={handleCloseModal}
      >
        <div className="fixed-search-overlay full-page-overlay">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="organ-modal-wrapper">
                  <h3>Search by Organs</h3>
                  <div className="search-organ-content">
                    {data?.map((item) => (
                      <Link
                        className="search-organ-card"
                        to={`/search/${item?.organ_name.toLowerCase()}`}
                      >
                        <figure className="search-organ-icon">
                          <img
                            src={item?.organ_image}
                            alt={item.organ_name}
                          />
                        </figure>
                        <h4>{item.organ_name}</h4>
                        <div className="btn btn-sm mx-auto">
                          <span>Explore</span>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Organs;
